import t from 'react-translate';
import NvAthenaFroala, { ResizeType } from 'athena/components/nv-athena-froala';
import { RteTagValue, ToolbarOptions } from 'froala/helpers/nv-froala-constants';
import { CustomCommunicationMessageType } from 'redux/schemas/models/mentorship-program-custom-communications';
import { config } from '@config/pendo.config.json';

type ContentEditorProps = {
  messageType?: CustomCommunicationMessageType;
};

const ContentEditor = ({ messageType }: ContentEditorProps) => {
  const translationBase = t.MENTORING_PROGRAMS.COMMUNICATIONS.COMMUNICATION_MODAL.EDIT_MODE;
  const dataQATag = config.pendo.athena.mentorshipProgram.communications.editCommunicationModal.contentInputField;

  return (
    <div className='content-wrapper mt-4 w-100'>
      <div className='semi-bold color-gray-2 mb-1'>
        {translationBase.CONTENT_SECTION.CONTENT()}
      </div>
      <NvAthenaFroala
        withForm
        required
        minHeight={300}
        name='content'
        resize={ResizeType.VERTICAL}
        scrollableContainer='body'
        toolbarButtons={[
          ToolbarOptions.BOLD,
          ToolbarOptions.ITALIC,
          ToolbarOptions.UNDERLINE,
          ToolbarOptions.FORMAT_UL,
          ToolbarOptions.FORMAT_OL,
          ToolbarOptions.INSERT_LINK,
        ]}
        placeholder={translationBase.PLACEHOLDERS.CONTENT()}
        withInsertTag
        extraTags={[RteTagValue.INSERT_PASSWORD_SENTENCE]}
        tagModalContext='mentorship'
        messageType={messageType}
        dataQa={dataQATag}
        ariaLabel={translationBase.CONTENT_SECTION.CONTENT()}
      />
    </div>
  );
};

export default ContentEditor;
